import { StyledFlex } from '@dreryk/react-components';

import {
   DetailQuestionViewModel,
   FieldScope,
   MedicalProfileTabFormController,
} from '../../tab/MedicalProfileTab.types';

import { DetailQuestionField } from './DetailQuestionField';

type DetailSurveyFieldsProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly questions: DetailQuestionViewModel[];
   readonly disabled: boolean;
   readonly scope?: FieldScope;
};

export const DetailSurveyFields = (props: DetailSurveyFieldsProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={16}>
         {props.questions.map((question) => (
            <DetailQuestionField
               key={question.questionId}
               register={props.register}
               templateCode={props.templateCode}
               question={question}
               disabled={props.disabled}
               scope={props.scope}
            />
         ))}
      </StyledFlex>
   );
};
